import gql from 'graphql-tag';

import { legacyEventSummaryFragment } from './event';

// Public Groups Fragment
export const groupPublicFragment = gql`
  fragment groupPublicFragment on Group {
    id
    name
    users {
      displayName
      pictureUrl
      primaryIdentityId
    }
  }
`;

// QUERY

// Full Group Query with private information, requires auth
// Adds filter to look for a specific eventId(s)
export const GroupQueryPrivate = gql`
  ${groupPublicFragment}
  ${legacyEventSummaryFragment}
  query GroupQuery($id: ID!, $eventIds: [Int]) {
    group(id: $id) {
      ...groupPublicFragment
      # private
      events(filters: { eventIds: $eventIds }) {
        eventId
        event {
          ...legacyEventSummaryFragment
        }
        entries {
          participants {
            primaryIdentityId
          }
        }
      }
    }
  }
`;

export const GroupForEventQuery = gql`
  query GroupQuery($id: ID!, $eventId: Int!) {
    group(id: $id) {
      events(filters: { eventIds: [$eventId] }) {
        entries {
          entry {
            id
            primaryIdentityId
          }
          participants {
            primaryIdentityId
            firstName
            lastName
          }
        }
      }
    }
  }
`;

export const ShortenUrl = gql`
  query ShortenUrl($url: String!) {
    shortenUrl(url: $url) {
      shortUrl
    }
  }
`;

export const GroupQueryPublic = gql`
  ${groupPublicFragment}
  query GroupQueryPublic($id: ID!) {
    group(id: $id) {
      ...groupPublicFragment
    }
  }
`;

// MUTATIONS
export const CreateGroupAndAddUser = gql`
  ${groupPublicFragment}
  mutation CreateGroupAndAddUser($name: String!, $googlePlaceId: String) {
    createGroupAndAddUser(name: $name, googlePlaceId: $googlePlaceId) {
      ...groupPublicFragment
    }
  }
`;

export const JoinGroupMutation = gql`
  mutation AddUserToGroup($groupId: String!) {
    addUserToGroup(groupId: $groupId)
  }
`;
